<template>
  <div >
    <Navbar/>
    <v-container id="policy" style="background: white; font-size: 16px; padding: 16px !important;font-family: 'CS ChatThaiUI' !important; text-align: center;" mt-5>
     <!--  <br>
     <h2 style="text-align: center;">Mobile</h2>
     <br>
     -->
     <img style="margin-top: 0vw; width: 30vw;" src="/static/image/android_photo/banner-homepage.jpg">


<!--      <div id="app">
  <v-app id="inspire">
    <v-carousel>
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade"
        transition="fade"
      ></v-carousel-item>
    </v-carousel>
  </v-app>
</div> -->


     <br>     <br>

       <a href="https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat" target="_blank">
        <img style="margin-top: 0vw; width: 15vw;" src="/static/image/googleplay.png">
      </a>
      <a href="https://itunes.apple.com/th/app/onechat/id1394435274?mt=8" target="_blank">
        <img style="margin-top: 0vw; width: 15vw;" src="/static/image/appstore.png">
      </a>
    </v-container>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
import Footer from '@/components/home/Footer'
export default {
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  })
}
</script>

<style type="text/css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/download.vue